import { render, staticRenderFns } from "./RegisterSongStep4Done.vue?vue&type=template&id=38ade702&scoped=true"
import script from "./RegisterSongStep4Done.vue?vue&type=script&lang=ts"
export * from "./RegisterSongStep4Done.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSongStep4Done.vue?vue&type=style&index=0&id=38ade702&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ade702",
  null
  
)

export default component.exports